<template>
    <div class="row">
        <div class="col-lg-12">


            <div v-if="errors.length > 0" class="alert alert-danger" role="alert">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <span v-for="error in errors">{{error}}<br/></span>
            </div>

            <div class="row">
                <div class="col-lg-6">

                    <div class="form-group">

                        <label for="reminder_subject">Email Subject <span class="text-danger text-xs">*</span></label>

                        <input class="form-control" type="text" id="reminder_subject" name="reminder_subject" v-model="webcast.reminder_subject" placeholder="" autofocus="" required="">
                    </div><!--form-group-->
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">

                    <div class="form-group">
                        <label for="reminder_message">Reminder Message <span class="text-danger text-xs">*</span></label>

                        <textarea class="form-control" name="reminder_message" v-model="webcast.reminder_message" id="reminder_message" placeholder="e.g. You are cordially invited to attend this event." spellcheck="false" rows="8"></textarea>
                    </div><!--form-group-->
                </div>
            </div>


            <div class="row">
                <div class="col">
                    <div class="form-group mb-0 clearfix">


                        <button class="btn btn-success btn-icon-split" @click="sendNow">
                            <span class="icon text-white-50">
                              <i class="fas fa-paper-plane"></i>
                            </span>
                            <span class="text">Send Now</span>
                        </button>
                    </div><!--form-group-->
                </div><!--col-->
            </div><!--row-->
        </div>
    </div>


</template>

<script>

export default {
    name: 'WebcastReminderForm',
    data() {
        return {
            webcast: {
                hashid: null,
            },
            errors: [],
            //stepper: null,
        }
    },
    components: {
    },
    props: {
        hashid: {
            type: String,
            // Object or array defaults must be returned from
            // a factory function
        },
    },
    watch: {

    },
    methods: {

        validate() {
            this.errors = []
            if (this.webcast.reminder_subject == null || this.webcast.reminder_subject.length == 0)
            {
                this.errors.push('Email Subject is required')
            }
            if (this.webcast.reminder_message == null || this.webcast.reminder_message.length == 0)
            {
                this.errors.push('Reminder Message is required')
            }

        },
        sendNow() {
            Swal.fire({
                title: 'Are you sure?',
                text: 'This webcast reminder will be sent immediately',
                icon: 'question',
                confirmButtonText: 'Send Now',
                cancelButtonText: 'No, Not Now',
                showCancelButton: true,
                focusCancel: true,
            }).then((result) => {
                if (result.value) {
                    this.draft = false
                    this.save()
                }
            })

        },
        async save() {

            let formData = new FormData()
            if (this.hashid)
                formData.append('webcast[hashid]', this.hashid)
            if (this.webcast.reminder_message)
                formData.append('webcast[reminder_message]', this.webcast.reminder_message)
            if (this.webcast.reminder_subject)
                formData.append('webcast[reminder_subject]', this.webcast.reminder_subject)

            formData.append('_method', 'POST')
            axios.post('/webcast/'+this.hashid+'/reminder', formData, {
                headers: {
                    //'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                Swal.fire({
                    title: 'Success',
                    text: 'Record saved successfully',
                    icon: 'success',
                    confirmButtonText: 'Done'
                }).then((result) => {
                    location.href='/webcast/'+this.hashid
                })
            }).catch((error) => {
                // TODO: handle validation error
                Swal.fire({
                    title: 'Error',
                    text: 'There are problems in the form',
                    icon: 'error',
                    confirmButtonText: 'OK'
                }).then((result) => {
                    this.errors = error.response.data.errors
                    window.scrollToTop()
                })
            })

        }
    },
    mounted() {
        /*axios.get('/api/webcast/'+this.hashid).then((response) => {
            this.webcast = _.merge(this.webcast,response.data.webcast)
        }).catch((error) => {
            Swal.fire({
                title: 'Error',
                text: 'Unable to retrieve record',
                icon: 'error',
                confirmButtonText: 'Dismiss'
            }).then((result) => {
                location.href='/webcast/'+this.hashid
            });
        });*/
        //this.stepper = new Stepper($('.bs-stepper')[0])
    }


}
</script>
<style>

</style>
